import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  type?: "button" | "submit" | "reset";
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  className?: string;
  text?: string;
}

export function Button({
  children,
  type = "button",
  onClick,
  disabled = false,
  className = "",
  ...props
}: ButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type={type}
      className={`font-bold shadow ${!disabled && "hover:opacity-90"} ${className || "rounded-md"}`}
      {...props}
    >
      {children}
    </button>
  );
}
